module.exports = __webpack_public_path__ + "static/media/27-skylde.3e827bca.mp3";